// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"366df3c1","307":"3a5c1369","822":"9c07cb00"}[chunkId] + ".chunk.js";
};